import { appConfig } from "@shared/utils/appConfig";
import {
  DEV_PORT_BY_DOMAIN_GROUP,
  DomainGroup,
  domainGroupEnum,
  getOtherDomainGroup,
} from "@shared/utils/domain-group";
import { useDomainGroup } from "./useDomainGroup";

const OTHER_DOMAIN_GROUP_ORIGIN: Record<
  DomainGroup,
  { staging: string; production: string }
> = {
  [domainGroupEnum.SIDEKICK]: {
    staging: "https://app.staging.sidekickgpt.dev",
    production: "https://app.sidekickgpt.io",
  },
  [domainGroupEnum.RADAR]: {
    staging: "https://app.staging.joinradar.ai",
    production: "https://app.joinradar.ai",
  },
};

// In development the "other domain" is the other brand's dev-server port
// (see DEV_PORT_BY_DOMAIN_GROUP), not a real hostname.
export const useOtherDomainGroupUrl = (path: string): string => {
  const otherDomainGroup = getOtherDomainGroup(useDomainGroup());

  if (appConfig.APP_ENV === "development") {
    return `http://localhost:${DEV_PORT_BY_DOMAIN_GROUP[otherDomainGroup]}${path}`;
  }

  const tier = appConfig.APP_ENV === "production" ? "production" : "staging";
  return `${OTHER_DOMAIN_GROUP_ORIGIN[otherDomainGroup][tier]}${path}`;
};
